// extracted by mini-css-extract-plugin
module.exports = {"row":"depositRewards_row__3YqXC","depositTotal":"depositRewards_depositTotal__2eLY1","value":"depositRewards_value__3wQRd","errorMessage":"depositRewards_errorMessage__3bBzk"};